import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chip", "count", "newTagInput", "chipsContainer"]
  static values = { url: String }

  toggle(event) {
    event.currentTarget.classList.toggle("contact-detail__suggestion--added")
    this.updateCount()
    this.save()
  }

  addNew(event) {
    if (event.key !== "Enter" && event.key !== ",") return
    event.preventDefault()

    const name = this.newTagInputTarget.value.trim()
    if (!name) return

    const existing = this.chipTargets.find(
      c => c.dataset.tagName?.toLowerCase() === name.toLowerCase()
    )

    if (existing) {
      existing.classList.add("contact-detail__suggestion--added")
    } else {
      const chip = this.buildChip(name)
      this.chipsContainerTarget.insertBefore(chip, this.newTagInputTarget)
    }

    this.newTagInputTarget.value = ""
    this.updateCount()
    this.save()
  }

  buildChip(name) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "contact-detail__suggestion contact-detail__suggestion--added"
    button.dataset.tagName = name
    button.dataset.tagManagerTarget = "chip"
    button.dataset.action = "click->tag-manager#toggle"

    const display = name.charAt(0).toUpperCase() + name.slice(1)
    const label = document.createTextNode(display)
    const check = document.createElement("span")
    check.className = "contact-detail__suggestion-check"
    check.textContent = "✓"

    button.appendChild(label)
    button.appendChild(check)
    return button
  }

  updateCount() {
    const selectedCount = this.chipTargets.filter(c =>
      c.classList.contains("contact-detail__suggestion--added")
    ).length

    if (this.hasCountTarget) {
      this.countTarget.textContent = `(${selectedCount})`
      this.countTarget.toggleAttribute("hidden", selectedCount === 0)
    }
  }

  async save() {
    const selected = this.chipTargets
      .filter(c => c.classList.contains("contact-detail__suggestion--added"))
      .map(c => c.dataset.tagName)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    formData.append("contact[tag_names]", selected.join(", "))
    formData.append("_method", "patch")

    try {
      await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/html"
        },
        body: formData,
        credentials: "same-origin"
      })
    } catch (e) {
      console.error("Failed to update tags", e)
    }
  }
}
